var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWorkspaceProject = function SvgWorkspaceProject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    fillRule: "evenodd",
    d: "M12 2a.5.5 0 0 1 .5.5v1.232l.832.555A1.5 1.5 0 0 1 14 5.535V6.5h.5A1.5 1.5 0 0 1 16 8v.5h.5A1.5 1.5 0 0 1 18 10v11.5a.5.5 0 0 1-1 0V10a.5.5 0 0 0-.5-.5h-9a.5.5 0 0 0-.5.5v11.5a.5.5 0 0 1-1 0V10a1.5 1.5 0 0 1 1.5-1.5H8V8a1.5 1.5 0 0 1 1.5-1.5h.5v-.965c0-.501.25-.97.668-1.248l.832-.555V2.5A.5.5 0 0 1 12 2m1 3.535V6.5h-2v-.965a.5.5 0 0 1 .223-.416L12 4.601l.777.518a.5.5 0 0 1 .223.416M9 8a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5v.5H9z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#16A34A",
    d: "M9.5 11a.5.5 0 0 0-1 0v2.714a.5.5 0 0 0 1 0zm0 6.786a.5.5 0 0 0-1 0V20.5a.5.5 0 0 0 1 0zM12 10.5a.5.5 0 0 1 .5.5v2.714a.5.5 0 0 1-1 0V11a.5.5 0 0 1 .5-.5m0 6.786a.5.5 0 0 1 .5.5V20.5a.5.5 0 0 1-1 0v-2.714a.5.5 0 0 1 .5-.5M15.5 11a.5.5 0 0 0-1 0v2.714a.5.5 0 0 0 1 0zm0 6.786a.5.5 0 0 0-1 0V20.5a.5.5 0 0 0 1 0z"
  })));
};
export default SvgWorkspaceProject;